import { ArrowForward } from '@mui/icons-material';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useSafeNavigation } from '../../../../hooks/useSafeNavigation';
import { ModalRoute } from '../../../../router/ModalRoute';

export const InvoiceManagementStartRemindingPage = () => {
  const params = useParams();
  const { safeNavigate } = useSafeNavigation();

  const handleConfirm = () => {
    safeNavigate(`/upload/invoice/${params.invoiceId}/billing`);
  };

  const handleCancel = () => {
    safeNavigate(`/invoice-management/invoices/${params.invoiceId}`);
  };

  return (
    <ModalRoute>
      <StartRemindingModalContent onConfirm={handleConfirm} onCancel={handleCancel} />
    </ModalRoute>
  );
};

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
};

const StartRemindingModalContent = ({ onConfirm, onCancel }: Props) => {
  const { t } = useTranslation('page-invoice-management');
  return (
    <>
      <DialogTitle>{t('startReminding.title')}</DialogTitle>
      <DialogContent>
        <p>{t('startReminding.description')}</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} size={'large'}>
          {t('startReminding.cancel')}
        </Button>
        <Button onClick={onConfirm} size={'large'} variant={'contained'} endIcon={<ArrowForward />}>
          {t('startReminding.confirm')}
        </Button>
      </DialogActions>
    </>
  );
};
